export const PAGE_PADDING = 8;
export const MAX_CONTENT_WIDTH = 600;
export const BUTTON_HEIGHT = 40;

export const WINNER_STEPS_LIST = [
  //  橫
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],

  // 縱
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8],

  // 斜
  [2, 4, 6],
  [0, 4, 8],
];
